import React from "react";
import EventCard from "./event-card";
import { StaticQuery, graphql } from "gatsby";

const EventsList = () => {
  return (
    <StaticQuery
      query={query}
      render={(data) => (
        <div>
          <div className="row">
            {data.allEvent.edges.map((event) => {
              return (
                <EventCard
                  image={event.node.image}
                  event={event.node}
                  key={event.node.id}
                />
              );
            })}
          </div>
        </div>
      )}
    />
  );
};

const query = graphql`
  query {
    allEvent(sort: { fields: [date], order: ASC }) {
      edges {
        node {
          image {
            childImageSharp {
              gatsbyImageData(layout: CONSTRAINED)
            }
          }
          id
          slug
          date
          name
          description
        }
      }
    }
  }
`;

export default EventsList;
